import request from "./request"

export function getDiscovery() {
  return request({ url: "/search/discovery_get", method: "get" })
}

export function getSuggestions(params) {
  return request({ url: "/search/suggest_get", method: "get", params })
}

export function searchContent(params) {
  return request({ url: "/search/result_get", method: "get", params })
}

export function deleteSearchHistory(data) {
  return request({ url: "/search/history_delete", method: "post", data })
}

export function clearSearchHistory() {
  return request({ url: "/search/history_clear", method: "post" })
}
